<ul class="nav nav-tabs justify-content-center">
    <ng-container *ngFor="let linkItem of listItems">
        <li class="nav-item">
            <a [ngClass]="{'active' : selectedItem === linkItem}" class="nav-link" href="javascript:;" (click)="onSelected(linkItem)">{{linkItem}}</a>
          </li>
    </ng-container>
  </ul>
